<template>
  <div class="address-input">
    <TextField
      class=""
      :label="$t('Planning.Name')"
      :model.sync="address.name"
      :placeholder="$t('Planning.Name')"/>
    <v-subheader class="h8-text text-start mt-2">
      {{ $t('Tenders.NewAddressNameText') }}
    </v-subheader>
    <Autocomplete
      v-if="mode == 'tender'"
      class="mt-4"
      item_text="title"
      item_value="code"
      :items.sync="cities"
      :label="$t('Common.CityName')"
      :loading="loading"
      :model.sync="address.city"
      :placeholder="$t('Common.CityName')"
      :search.sync="search_city"
      show_no_data>
      <template v-slot:item="{ item: addressItem }">
        <v-list-item-content v-if="addressItem">
          <v-list-item-title>{{ addressItem.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ addressItem.regionTitle }}, {{ addressItem.countryTitle }}</v-list-item-subtitle>
        </v-list-item-content>
        <span v-else> {{ $t('Common.CityName') }} </span>
      </template>
    </Autocomplete>
    <TextField
      v-else
      class-name=" mt-8"
      :label="$t('Common.CityName')"
      :model.sync="address.city"
      :placeholder="$t('Common.CityName')"/>
    <v-row
      class="mt-6"
      no-gutters>
      <TextField
        class-name=""
        :label="$t('Common.StreetType')"
        :model.sync="address.street_type"
        :placeholder="$t('Common.StreetType')"
        style="max-width: 128px "/>
      <TextField
        class-name=" ml-4"
        id_name="autocomplete"
        :label="$t('Common.StreetName')"
        :model.sync="address.street_name"
        :placeholder="$t('Common.StreetName')"
        @focus="geolocate"/>
    </v-row>
    <v-row
      class="mt-8 flex-nowrap"
      no-gutters>
      <TextField
        class-name="input mr-4"
        :label="$t('Common.House')"
        :model.sync="address.house"
        :placeholder="$t('Common.House')"/>

      <TextField
        class-name="input"
        :label="$t('Common.Corps')"
        :model.sync="address.corps"
        :placeholder="$t('Common.Corps')"/>
    </v-row>
    <TextField
      class-name="input col-6 pa-0 mt-8"
      :label="$t('Common.Index')"
      :model.sync="address.index"
      :placeholder="$t('Common.Index')"/>
  </div>
</template>
<script>
import TextField from 'components/common/inputs/TextField.vue'
import Autocomplete from 'components/common/inputs/Autocomplete.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'addresInputBlock',
  data() {
    return {
      dialog: false,
      cities: [],
      loading: false,
      timeout: 0,
      search_city: ''
    }
  },
  props: {
    addresses: Array,
    item: Object,
    mode: String
  },
  computed: {
    address: {
      get() {
        return this.item
      },
      set(value) {
        this.$emit('update:item', value)
      }
    },

  },
  methods: {
    getCity(name) {
      this.loading = true
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        api.getCity(name)
          .then(res => this.cities = res)
          .finally(() => this.loading = false)
      }, 1000)
    },
    geolocate() {
      // let selfish = this
      // if (navigator.geolocation) {
      //   selfish.$log('geolocate10', selfish, this, selfish?.autocomplete )
      //   navigator.geolocation.getCurrentPosition(function(position) {
      //     selfish.$log('geolocate1', selfish, this,  selfish?.autocomplete , position )
      //     var geolocation = {
      //       lat: position.coords.latitude,
      //       lng: position.coords.longitude
      //     }
      //     selfish.$log('geolocate2', selfish, this,geolocation,  selfish?.autocomplete )
      //     var circle = new window.google.maps.Circle(
      //       {center: geolocation, radius: position.coords.accuracy})
      //     selfish?.$log('geolocate3', selfish, this,geolocation, circle, selfish?.autocomplete )
      //     selfish?.autocomplete?.setBounds(circle.getBounds())
      //   })
      // }
    }
  },
  watch: {
    search_city(val) {
      val && this.getCity(val)
    }
  },
  components: {
    TextField,
    Autocomplete
  }
}
</script>

<style lang="scss" scoped>
.address-input *{
  color: var(--black-color);
}
.inputs {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  .input {
    max-width: 189px;
    width: 189px;
    min-width: 189px;
  }
}
</style>

<style lang="scss">
.add-criterion-manually-dialog {
  .variants  .input {
    max-width: 150px;
  }
}
</style>
